<template>        
    <div class="ibox custom-box h-100 mb-0" v-if="is_dashboard == 'yes'">
        <div class="ibox-title dashboard_title">
            <div class="content-div-title">Leave Balances</div>
        </div> 
        <div class="dash-ibox-content mt-3">
            <div class="leave-balance-info border-bottom p-2" v-for="leave_type in leave_available" :key="leave_type.id">
                <span class="title">
                    <img v-if="leave_type.leave_title == 'Sick Leave'" v-bind:src="$api_url+'/images/menu/hospital.svg'" class="mr-3"/>
                    <img v-else-if="leave_type.leave_title == 'Casual Leave'" v-bind:src="$api_url+'/images/menu/plane.png'" class="mr-3"/>
                    <img v-else v-bind:src="$api_url+'/images/menu/clock.png'" class="mr-3"/>
                    {{leave_type.leave_title}}
                </span>
                <span class="float-right">{{leave_type.remaining_days}}</span>
            </div>
            <recent-leave-request-front  :is_dashboard="this.is_dashboard"></recent-leave-request-front>
            
            <div class="text-center"><button @click="setMe('employee-leave-attendance-wrapper-front')" class="dashboard-more-btn custom-primary-btn">View More</button></div>
        </div>
    </div>
    <div class="ibox custom-box" v-else>
        <div class="ibox-title dashboard_title">
            <h3>
                <img class="m-r-sm" :src="img_src + 'position.png'" width="16">
                Leave Balances
            </h3>
        </div>
        <div class="ibox-content">
            <template v-if="count_leave_available >0">
                <table class="table dataTable">
                    <thead>
                        <tr class="table-head">
                            <td>Leave Type</td>
                            <td>Total Allocated Leaves</td>
                            <td>Remaining Leaves</td>
                        </tr>
                    </thead>
                    <tbody>
                        
                        <tr class="table-row hover-bg" v-for="leave_type in leave_available" :key="leave_type.id">
                            
                                <td>{{leave_type.leave_title}}</td>
                                <td>{{leave_type.leave_days}} Days</td>
                                <!-- <td>{{leave_type.remaining_days}} Days</td> -->
                                <td>
                                    <template v-if="leave.leave_day == 0">                                    
                                        {{leave.number_of_days}} 
                                        <span v-if="leave.number_of_days > 1">days</span>
                                        <span v-else>day</span>
                                    </template>
                                    <template v-else-if="leave.leave_day == 1">First Half</template>
                                    <template v-else-if="leave.leave_day == 2">Second Half</template>
                                </td>
                            
                        </tr>
                        
                        
                    </tbody>
                </table>
            </template>
            <template v-else>                                             
                No Leave Policy Assigned.  
            </template>
        
        </div>
    </div>
</template>
<script> 
  
    export default{
      mounted() {
        },

        props: ['is_dashboard'],
        components: {
        },
        data(){

            return {
            leave_available : [],
            count_leave_available : 0, 
            leaves:[],
            leavetypes : [],
            img_src : this.$api_url+'/images/employee_dasboard/', 
               page: { month: '', year: '' },       
            }
        },
        methods:{
            
            
         getLeaves:function() 
        {   
            
            axios.get(this.$api_url+'/front/employee/leaves' , {
                params: {
                    //id: x
                }
            }).then(function(response){
                
                if(response.data.length != 0)
                {
                    //console.log( response.data);
                    
                    this.leave_limit = response.data.limit;

                    this.leave_available = response.data.available;
                    this.count_leave_available = response.data.available.length;
                    

                    if(this.leaves.length == 0)
                    {
                        this.blankmsg = 'Looks like no leave applied for the employee yet.';
                    }

                    
                }       
                
            }.bind(this));

        },
            
        setMe :function(x)
        {
            
            
            if(x == 'request-leave')            
            this.$bvModal.show('bv-modal-leave');
            else
            {            
                let childdata = {component_name:x};                    
                this.$emit('childToParent', childdata);
            }
            
        },
            
            
        },
        created: function(){
            this.getLeaves();         
        },
 
    }

</script>